<template>
    <span class="chip-number" :class="classBkgFormatted" :style="{ width: widthChip }">
        <span class="semibold" :class="colorNumber">{{ numberFormatted }}</span>
    </span>
</template>

<script>
export default {
    props: {
        number: {
            type: Number,
            required: false,
            default: 0,
        },
        classBkg: {
            type: String,
            required: false,
            default: 'alert-50-bkg',
        },
    },
    computed: {
        numberFormatted() {
            switch (this.number.toString().length) {
                case 1:
                    return this.number;
                case 2:
                    return this.number;
                default:
                    return '99+';
            }
        },
        widthChip() {
            switch (this.number.toString().length) {
                case 1:
                    return '16px';
                case 2:
                    return '24px';
                default:
                    return '34px';
            }
        },
        colorNumber() {
            if (this.number === 0) {
                return 'gray-80';
            } else {
                return 'white';
            }
        },
        classBkgFormatted() {
            if (this.number === 0) {
                return 'gray-40-bkg';
            } else {
                return this.classBkg;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.chip-number {
    display: flex;
    width: 16px;
    height: 16px;
    border-radius: 10px;
    align-items: center;
    justify-content: center;
    font-size: var(--font-size-12);
    line-height: 1;

    @media screen and (max-width: 1439px) {
        font-size: 9px;
    }
}
</style>
